<template>
    <div class="item">
        <div class="item-header">
            <img :src="headerBg" alt="header-bg">
            <span style="position: absolute">
                {{ title }}
            </span>
        </div>
        <div class="item-bg">
            <img :src="bodyBg" alt="bodyBg-bg">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import headerBg from "../assets/images/item-header-bg.png";
import bodyBg from "../assets/images/item-body-bg.png";

export default {
	name: "data-item",
	props: {
		title: {
			type: String,
			default: ''
		}
	},
	data() {
		return {headerBg, bodyBg}
	}
}
</script>

<style scoped lang="less">
.item-header {
  width: 100%;
  height: 0.75rem;
  position: relative;
  color: #fff;
  font-size: 0.36rem;
  display: flex;
  align-items: center;
  padding-left: 0.4rem;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.item-bg {
  width: 100%;
  height: calc(100% - 0.75rem);
  position: relative;
  padding-left: 2px;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0px;
  }
}

</style>
